import React, {useRef, useState} from 'react';
import {BASEURL} from "@api/baseUrl"
import {Button, Drawer, Form, message, Modal, Space, Upload} from "antd"
import {useDispatch} from "react-redux"
import {useHistory} from "react-router-dom"
import {columnsFn} from "./data"
import ProTable, {ActionType} from "@ant-design/pro-table"
import {checkGetCardOperatorList} from '@api/product';
import {productApi} from '@utils/util';
import {PROCODE_DYNAMICLIVECHECK} from '@utils/enum';
import {ExportButton} from '@components/index';
import {
    CodeOutlined,
    ExclamationCircleOutlined,
    LinkOutlined,
    PlayCircleOutlined,
    UploadOutlined
} from "@ant-design/icons";
import {dynamicFaceCheck} from "@api/product/identityCheck";
import ProForm from "@ant-design/pro-form";
import type {UploadFile} from "antd/es/upload/interface";

// 接口请求的 api 层
const getApi = productApi(checkGetCardOperatorList)

// 视频类型枚举
const VIDEO_TYPE = {
    URL: 'URL',
    UP: 'UP'
};

// 在线发送
export default () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const formRef = useRef()
    const otherParams = { productCode: PROCODE_DYNAMICLIVECHECK }
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
    const [modalProps, setModalProps] = useState({ visible: false, title: '新增', params: {} })
    const ref = useRef<ActionType>(null);

    const operate = async (type: any, record: any) => {
        // operate 函数为增删改查需要处理的业务
    }

    const getListApi = async (params: any, sorter: any, filter: any) => {
        const { data } = await getApi({ ...params }, false)
        const { values, total } = data || {}
        return {
            data: values || [],
            success: true,
            total
        }
    }

    const columns = columnsFn(operate)
    const getQueryParams = () => ({
        // @ts-ignore
        ...formRef.current?.getFieldsFormatValue(),
        ...otherParams
    })

    const onSuccess = () => {
        console.log('处理后的成功回调触发了')
        reFresh()
    }

    const reFresh = () => {
        // @ts-ignore
        ref.current?.clearSelected()
        ref.current?.reload()
    }

    const [uploadVisible, setUploadVisible] = useState(false);

    const OnlineRequest = ({ onOk }: { onOk?: () => void }) => {
        const [form] = Form.useForm();
        const [loading, setLoading] = useState(false);
        const [fileList, setFileList] = useState<any[]>([]);
        const [videoType, setVideoType] = useState<string>(VIDEO_TYPE.URL);
        const [videoPreview, setVideoPreview] = useState<string>('');
        const motions = Form.useWatch('motions', form);
        const videoUrl = Form.useWatch('videoUrl', form);

        const [videoInfo, setVideoInfo] = useState<{
            name: string;
            size: number;
            lastModified: string;
            type: string;
            duration?: number;
            dimensions?: { width: number; height: number };
        } | null>(null);

        // 动作序列选项
        const motionOptions = [
            { label: '眨眼', value: 'BLINK' },
            { label: '张嘴', value: 'MOUTH' },
            { label: '点头', value: 'NOD' },
            { label: '摇头', value: 'YAW' },
        ];

        // 监听图片类型变化
        const handleVideoTypeChange = (value: string) => {
            setVideoType(value);
            // 清空相关字段
            if (value === VIDEO_TYPE.URL) {
                form.setFieldsValue({ videoUrl: '' });
                setFileList([]);
                setVideoPreview('');
                setVideoInfo(null);
            } else {
                form.setFieldsValue({ videoUrl: '' });
            }
            form.setFieldsValue({ videoType: value });
        };

        // 验证视频文件
        const validateVideoFile = (file: File) => {
            // 验证文件类型
            const validTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
            const validExtensions = ['.mp4', '.mov', '.avi'];
            const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));

            const isVideo = validTypes.includes(file.type) || validExtensions.includes(fileExtension);
            if (!isVideo) {
                message.error('只能上传 MP4、MOV、AVI 格式的视频文件');
                return false;
            }

            // 验证文件大小（限制20MB）
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                message.error('视频大小不能超过20MB');
                return false;
            }

            // 验证文件名长度
            if (file.name.length > 100) {
                message.error('文件名过长，请重命名后上传');
                return false;
            }

            return true;
        };

        // 获取视频时长和尺寸
        const getVideoInfo = (file: File): Promise<{ duration: number; dimensions: { width: number; height: number } }> => {
            return new Promise((resolve) => {
                const video = document.createElement('video');
                const url = URL.createObjectURL(file);
                video.onloadedmetadata = () => {
                    resolve({
                        duration: video.duration,
                        dimensions: { width: video.videoWidth, height: video.videoHeight }
                    });
                    URL.revokeObjectURL(url);
                };
                video.src = url;
            });
        };

        // 处理视频上传
        const handleVideoUpload = async (file: File) => {
            try {
                // 验证文件
                if (!validateVideoFile(file)) {
                    return false;
                }

                // 获取视频信息
                const videoInfoData = await getVideoInfo(file);
                const previewUrl = URL.createObjectURL(file);

                // 设置视频信息
                setVideoInfo({
                    name: file.name,
                    size: file.size,
                    lastModified: new Date(file.lastModified).toLocaleString(),
                    type: file.type,
                    duration: videoInfoData.duration,
                    dimensions: videoInfoData.dimensions
                });

                // 设置预览
                setVideoPreview(previewUrl);

                message.success('视频上传成功');
                return false;
            } catch (error) {
                message.error('视频上传失败');
                console.error('视频上传失败:', error);
                return false;
            }
        };

        // 自定义上传请求
        const customRequest = ({ file, onSuccess }: any) => {
            // if (file instanceof File) {
            //     handleVideoUpload(file);
            //     setFileList([file]);
            // }
            const uploadFile: UploadFile = {
                uid: file.uid,
                name: file.name,
                status: 'done',
                originFileObj: file,
            };
            handleVideoUpload(file);
            setFileList([uploadFile]);
            onSuccess?.('ok');
        };

        // 移除视频
        const removeVideo = () => {
            if (videoPreview) {
                URL.revokeObjectURL(videoPreview);
            }
            setFileList([]);
            setVideoPreview('');
            setVideoInfo(null);
        };

        // 获取文件大小格式
        const formatFileSize = (bytes: number) => {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        };

        // 格式化视频时长
        const formatDuration = (seconds: number) => {
            if (!seconds) return '0秒';
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins > 0 ? mins + '分' : ''}${secs}秒`;
        };

        // 验证URL格式
        const validateVideoUrl = (url: string): boolean => {
            const urlPattern = /^(http|https):\/\/[^\s$.?#].[^\s]*$/;
            const videoExtensionPattern = /\.(mp4|mov|avi)(\?.*)?$/i;

            if (!urlPattern.test(url)) {
                return false;
            }

            if (!videoExtensionPattern.test(url)) {
                message.warning('URL可能不是视频链接，请确保链接指向视频文件');
            }

            return true;
        };

        // 检查提交按钮是否应该禁用
        const isSubmitDisabled = React.useMemo(() => {
            if (!motions) return true;

            if (videoType === VIDEO_TYPE.URL) {
                return !videoUrl || videoUrl.trim() === '';
            }

            return fileList.length === 0;
        }, [motions, videoType, videoUrl, fileList.length]);
        const finalDisabled = isSubmitDisabled || loading;


        // 开始验证
        const startCheck = async () => {
            try {
                if (loading) return;
                setLoading(true);
                const values = await form.validateFields();
                // 验证视频数据
                if (videoType === VIDEO_TYPE.URL && !values.videoUrl) {
                    message.warning('请输入视频URL地址');
                    return;
                }

                if (videoType === VIDEO_TYPE.UP && !fileList.length) {
                    message.warning('请上传视频文件');
                    return;
                }
                let submitting = false;

                // 构建请求参数
                const params: any = {
                    motions: values.motions,
                };

                // 根据视频类型设置不同的视频字段
                if (values.videoType === VIDEO_TYPE.URL) {
                    params.url = values.videoUrl;
                } else if (values.videoType === VIDEO_TYPE.UP && fileList.length) {
                    params.file = fileList[0].originFileObj;
                }
               Modal.confirm({
                    title: '确认要开始动态活体检测吗？',
                    icon: <ExclamationCircleOutlined />,
                    content: (
                        <div>
                            <div>即将检测的信息：</div>
                            <div style={{ marginTop: 8 }}>
                                <strong>动作序列：</strong>
                                {motionOptions.find(m => m.value === values.motions)?.label}
                            </div>
                            <div style={{ marginTop: 4 }}>
                                <strong>视频类型：</strong>
                                {values.videoType === VIDEO_TYPE.URL ? '视频路径' : '上传视频'}
                            </div>
                            {values.videoType === VIDEO_TYPE.URL && (
                                <div style={{ marginTop: 4 }}>
                                    <strong>视频地址：</strong>
                                    <span style={{ fontSize: 12, color: '#666', wordBreak: 'break-all' }}>
                                        {values.videoUrl}
                                    </span>
                                </div>
                            )}
                            {values.videoType === VIDEO_TYPE.UP && videoInfo && (
                                <div style={{ marginTop: 8 }}>
                                    <strong>视频文件：</strong>{videoInfo.name}
                                    <div style={{ marginTop: 4, color: '#666', fontSize: 12 }}>
                                        文件大小：{formatFileSize(videoInfo.size)}
                                    </div>
                                </div>
                            )}
                            <div style={{ marginTop: 8, color: '#faad14' }}>
                                启动后将不支持取消，请确认！
                            </div>
                        </div>
                    ),
                   okButtonProps: {
                       loading: loading,
                       disabled: loading,
                   },
                    onOk: async () => {
                        try {
                            if (submitting) return;
                            submitting = true;
                            await dynamicFaceCheck(params);
                            message.success('提交成功，请稍后刷新页面查看检测结果');

                            setTimeout(() => {
                                removeVideo();
                                form.resetFields();
                                onOk?.();
                            }, 1000);

                            setTimeout(() => {
                                reFresh();
                            }, 700);
                        } catch (e: any) {
                            console.error('表单验证失败:', e.message);
                        } finally {
                            setTimeout(() => {setLoading(false);submitting=false}, 1000);
                        }
                    },
                    onCancel: () => {
                        submitting = false;
                        setLoading(false);
                    },
                });
            } catch (error) {
                console.error('表单验证失败:', error);
                setTimeout(() => setLoading(false), 1000);
            }
        };

        // 自定义提交按钮
        const CustomSubmitter = () => (
            <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Button
                    type="primary"
                    size="large"
                    style={{ width: 200 }}
                    onClick={startCheck}
                    loading={loading}
                    disabled={finalDisabled}
                >
                    开始验证
                </Button>
                <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                    {!finalDisabled ? '信息已准备就绪' : '请填写相关信息'}
                </div>
            </div>
        );

        return (
            <div style={{ padding: '0 20px' }}>
                <ProForm
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    submitter={{
                        render: () => <CustomSubmitter />
                    }}
                    initialValues={{
                        videoType: VIDEO_TYPE.URL
                    }}
                >
                    {/* 动作序列选择 */}
                    <ProForm.Item
                        label="用户动作序列"
                        name="motions"
                        rules={[{ required: true, message: '请选择用户动作序列' }]}
                    >
                        <select
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #d9d9d9',
                                borderRadius: '4px',
                                outline: 'none',
                                backgroundColor: 'white'
                            }}
                            onChange={(e) => form.setFieldsValue({ motions: e.target.value })}
                        >
                            <option value="">请选择用户动作序列</option>
                            {motionOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </ProForm.Item>

                    {/* 视频类型选择 - 使用单选框 */}
                    <ProForm.Item
                        label="调用类型"
                        name="videoType"
                        rules={[{ required: true, message: '请选择调用类型' }]}
                    >
                        <div style={{ display: 'flex', gap: '16px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="videoType"
                                    value={VIDEO_TYPE.URL}
                                    checked={videoType === VIDEO_TYPE.URL}
                                    onChange={(e) => handleVideoTypeChange(e.target.value)}
                                    style={{ marginRight: '8px' }}
                                />
                                <Space>
                                    <LinkOutlined />
                                    <span>视频URL地址</span>
                                </Space>
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="videoType"
                                    value={VIDEO_TYPE.UP}
                                    checked={videoType === VIDEO_TYPE.UP}
                                    onChange={(e) => handleVideoTypeChange(e.target.value)}
                                    style={{ marginRight: '8px' }}
                                />
                                <Space>
                                    <CodeOutlined />
                                    <span>上传视频文件</span>
                                </Space>
                            </label>
                        </div>
                    </ProForm.Item>

                    {/* 动态显示视频地址输入框或视频上传 */}
                    <Form.Item noStyle shouldUpdate>
                        {() => {
                            const currentVideoType = form.getFieldValue('videoType');

                            return (
                                <>
                                    {/* 当选择 URL 时显示视频地址输入框 */}
                                    {currentVideoType === VIDEO_TYPE.URL && (
                                        <ProForm.Item
                                            label="视频URL地址"
                                            name="videoUrl"
                                            rules={[
                                                { required: true, message: '请输入视频URL地址' },
                                                {
                                                    pattern: /^(http|https):\/\/[^ "]+$/,
                                                    message: '请输入有效的视频URL地址'
                                                }
                                            ]}
                                        >
                                            <textarea
                                                placeholder="请输入视频URL地址，如：https://example.com/video.mp4"
                                                style={{
                                                    width: '100%',
                                                    minHeight: '80px',
                                                    padding: '8px 12px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    outline: 'none',
                                                    resize: 'vertical'
                                                }}
                                                rows={3}
                                                onChange={(e) => form.setFieldsValue({ videoUrl: e.target.value })}
                                            />
                                        </ProForm.Item>
                                    )}

                                    {/* 当选择 UP 时显示视频上传 */}
                                    {currentVideoType === VIDEO_TYPE.UP && (
                                        <ProForm.Item
                                            label="视频文件"
                                            name="video"
                                            rules={[{ required: true, message: '请上传视频文件' }]}
                                            validateStatus={fileList.length ? 'success' : 'error'}
                                            help={!fileList.length ? '请上传有效的视频文件' : ''}
                                        >
                                            <div style={{ marginBottom: 24 }}>
                                                <div style={{ marginBottom: 8 }}>
                                                    <Upload
                                                        accept="video/*,.mp4,.mov,.avi"
                                                        showUploadList={false}
                                                        // beforeUpload={handleVideoUpload}
                                                        customRequest={customRequest}
                                                        fileList={fileList}
                                                        // onChange={({ fileList }) => setFileList(fileList)}
                                                        maxCount={1}
                                                    >
                                                        <Button type="primary" ghost icon={<UploadOutlined />}>
                                                            选择视频文件
                                                        </Button>
                                                    </Upload>
                                                    <span style={{ marginLeft: 12, fontSize: 12, color: '#999' }}>
                                                        支持 MP4、MOV、AVI 格式，最大 20MB
                                                    </span>
                                                </div>

                                                {/* 视频信息预览 */}
                                                {videoInfo && videoPreview && (
                                                    <div style={{
                                                        marginTop: 12,
                                                        padding: 16,
                                                        border: '1px dashed #d9d9d9',
                                                        borderRadius: 6,
                                                        backgroundColor: '#fafafa'
                                                    }}>
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: 'bold', marginBottom: 8 }}>视频信息</div>
                                                                <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                                    <strong>文件名：</strong>
                                                                    <span style={{ fontFamily: 'monospace' }}>{videoInfo.name}</span>
                                                                </div>
                                                                <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                                    <strong>文件大小：</strong>
                                                                    <span>{formatFileSize(videoInfo.size)}</span>
                                                                </div>
                                                                <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                                    <strong>修改时间：</strong>
                                                                    <span>{videoInfo.lastModified}</span>
                                                                </div>
                                                                <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                                    <strong>视频类型：</strong>
                                                                    <span>{videoInfo.type}</span>
                                                                </div>
                                                                {videoInfo.dimensions && (
                                                                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                                        <strong>视频尺寸：</strong>
                                                                        <span>{videoInfo.dimensions.width} × {videoInfo.dimensions.height} 像素</span>
                                                                    </div>
                                                                )}
                                                                {videoInfo.duration && (
                                                                    <div style={{ fontSize: 12, color: '#666' }}>
                                                                        <strong>视频时长：</strong>
                                                                        <span>{formatDuration(videoInfo.duration)}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <div style={{
                                                                    width: 200,
                                                                    height: 120,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    overflow: 'hidden',
                                                                    borderRadius: 8,
                                                                    border: '1px solid #e8e8e8',
                                                                    backgroundColor: '#000'
                                                                }}>
                                                                    <video
                                                                        src={videoPreview}
                                                                        controls
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                            maxHeight: '100%',
                                                                            objectFit: 'contain'
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div style={{ marginTop: 8 }}>
                                                                    <Button type="link" danger onClick={removeVideo} size="small">
                                                                        移除
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </ProForm.Item>
                                    )}
                                </>
                            );
                        }}
                    </Form.Item>
                </ProForm>

                {/* 使用说明 */}
                <div style={{
                    marginTop: 24,
                    padding: 16,
                    border: '1px solid #e8e8e8',
                    borderRadius: 6,
                    backgroundColor: '#f9f9f9'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 12, color: '#333' }}>
                        使用说明
                    </div>
                    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#666' }}>
                        <div>🎬 <strong>动态活体检测验证模式：</strong></div>
                        <div>1. 选择用户动作序列（单选），支持眨眼、张嘴、点头、摇头动作</div>
                        <div>2. 选择调用类型：视频URL地址或上传视频文件</div>
                        <div>3. <strong>视频URL地址模式：</strong>输入完整的视频URL地址（需支持公网访问）</div>
                        <div>4. <strong>上传视频文件模式：</strong>点击“选择视频文件”上传需要检测的视频</div>
                        <div>5. 支持 MP4、MOV、AVI 格式，单个文件最大 20MB</div>
                        <div>6. 上传后可预览视频信息，可随时移除重新上传</div>
                        <div style={{ marginTop: 12 }}>
                            ⚠️ <strong>重要注意事项：</strong>
                        </div>
                        <div>• 请确保选择正确的动作序列</div>
                        <div>• 视频URL地址模式需确保URL可公开访问</div>
                        <div>• 视频中的人脸应清晰可见，光线良好</div>
                        <div>• 视频中的人物应按照选择的动作序列完成相应动作</div>
                        <div>• 确保视频中人物完成动作的清晰度和完整性</div>
                        <div>• 避免使用模糊、光线不足的视频</div>
                        <div>• 动态活体检测用于核实视频是否为真人实时拍摄</div>
                        <div>• 提交成功后，检测结果会显示在调用明细中</div>
                        <div>• 可在表格中查看历史记录并导出结果</div>
                        <div>• 该调用会产生一定费用,请确认余额充足</div>
                    </div>
                </div>

                {/* 底部提示 */}
                <div style={{
                    marginTop: 16,
                    padding: 12,
                    border: '1px dashed #91d5ff',
                    borderRadius: 6,
                    backgroundColor: '#e6f7ff'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff' }}>
                        <span style={{ marginRight: 8 }}>💡</span>
                        <span style={{ fontSize: 13 }}>
                            动态活体检测是重要的反欺诈手段，适用于远程开户、高安全等级实名认证等场景
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProTable<any>
                style={{ flex: 1, overflow: 'scroll' }}
                scroll={{ x: 1300 }}
                columns={columns}
                params={otherParams}
                request={getListApi}
                formRef={formRef as any}
                options={{ reload: false, density: false, setting: false }}
                toolbar={{
                    actions: [
                        <ExportButton
                            key="export"
                            type='primary'
                            action={`${BASEURL}/web/product/exportCardOperatorList`}
                            param={getQueryParams}
                            btnText="导出"
                        />,
                        <Button
                            key="online"
                            type="primary"
                            onClick={() => setUploadVisible(true)}
                            style={{ marginLeft: 8 }}
                        >
                            在线验证
                        </Button>,
                    ],
                }}
                rowKey="tiId"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, showQuickJumper: true }}
                actionRef={ref as any}
                search={{
                    optionRender: (searchConfig, formProps, dom) => [...dom.reverse()]
                }}
            />
            <Drawer
                title={
                    <Space>
                        <PlayCircleOutlined />
                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>动态活体检测验证</span>
                    </Space>
                }
                open={uploadVisible}
                width={800}
                onClose={() => {
                    setUploadVisible(false);
                }}
                destroyOnClose
            >
                <OnlineRequest
                    onOk={() => {
                        setUploadVisible(false);
                        setTimeout(() => {
                            reFresh();
                        }, 1000);
                    }}
                />
            </Drawer>
        </>
    );
}